"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _dashboard = require("@/api/dashboard");
var _permission = require("@/utils/permission");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
// +----------------------------------------------------------------------
// | CRMEB [ CRMEB赋能开发者，助力企业发展 ]
// +----------------------------------------------------------------------
// | Copyright (c) 2016~2026 https://www.crmeb.com All rights reserved.
// +----------------------------------------------------------------------
// | Licensed CRMEB并不是自由软件，未经许可不能去掉CRMEB相关版权
// +----------------------------------------------------------------------
// | Author: CRMEB Team <admin@crmeb.com>
// +----------------------------------------------------------------------
// 权限判断函数
var _default = exports.default = {
  data: function data() {
    return {
      grid: {
        xl: 12,
        lg: 12,
        md: 12,
        sm: 12,
        xs: 24
      },
      pageviewData: [],
      payData: []
    };
  },
  methods: {
    checkPermi: _permission.checkPermi,
    // 获取商品浏览量排行榜
    getPageviewData: function getPageviewData() {
      var _this = this;
      (0, _dashboard.pageviewDataApi)().then(function (res) {
        _this.pageviewData = res;
      });
    },
    // 获取商品支付排行榜
    getPayData: function getPayData() {
      var _this2 = this;
      (0, _dashboard.payDataApi)().then(function (res) {
        _this2.payData = res;
      });
    }
  },
  mounted: function mounted() {
    if ((0, _permission.checkPermi)(['merchant:statistics:home:product:pageview:ranking'])) this.getPageviewData();
    if ((0, _permission.checkPermi)(['merchant:statistics:home:product:pay:ranking'])) this.getPayData();
  }
};